import React from 'react'
import { useCtxParams } from '../../../../context/useCommonCtx'
import { isArabic } from '../../../../i18n/useTranslation'

const BAR_BORDER_WIDTH = 1
export const BAR_BORDER_RADIUS = 2
const MIN_BAR_WIDTH = 24
const MAX_BAR_WIDTH = 48
const TITLE_HEIGHT = 20
const TITLE_MARGIN_TOP = 4

type HBarProps = {
    index: number
    maxForCurrent: number
    val: number
    barHeight: string
    fillHeight: string
    isEmpty: boolean
    isSelected: boolean
    isSecondarySelected: boolean
    isExceeding: boolean
    isHighlighted: boolean
    fillColor: string
    title: string
    hasTitles: boolean
    onSelectBar?: (index: number) => void
    dataBarIndex: number
    containerHeight: string
}

export const HBar = ({
    index,
    maxForCurrent,
    val,
    barHeight,
    fillHeight,
    isEmpty,
    isSelected,
    isSecondarySelected,
    isExceeding,
    isHighlighted,
    fillColor,
    title,
    hasTitles,
    onSelectBar,
    dataBarIndex,
    containerHeight,
}: HBarProps) => {
    const normalBorderWidth = isHighlighted
        ? BAR_BORDER_WIDTH * 4
        : BAR_BORDER_WIDTH

    const borders = {
        borderStyle: 'solid' as const,
        borderRadius: BAR_BORDER_RADIUS,
        borderLeftWidth: normalBorderWidth,
        borderLeftColor: 'var(--dark-color)',
        borderRightWidth: normalBorderWidth,
        borderRightColor: 'var(--dark-color)',
        borderBottomWidth: normalBorderWidth,
        borderBottomColor: 'var(--dark-color)',
        borderTopWidth: isExceeding ? BAR_BORDER_WIDTH * 6 : normalBorderWidth,
        borderTopColor: isExceeding ? 'red' : 'var(--dark-color)',
    }

    const params = useCtxParams()

    return (
        <div
            data-bar-index={dataBarIndex}
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                flex: 1,
                maxWidth: MAX_BAR_WIDTH,
                minWidth: MIN_BAR_WIDTH,
                position: 'relative',
                zIndex: 1,
                ...(isArabic(params) ? { direction: 'rtl' } : { direction: 'ltr' })
            }}
        >
            {/* 1) Bar container with hit zone */}
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: containerHeight,
                    display: 'flex',
                    alignItems: 'flex-end',
                }}
            >
                {/* 2) Invisible hit zone covering full bar container height */}
               {onSelectBar && <div
                    onClick={() => onSelectBar?.(index)}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        cursor: 'pointer',
                        zIndex: 2,
                        // FIXME required ?
                        // background: 'transparent',
                        // outline: 'none',
                        // border: 'none',
                    }}
                />}
                
                {/* 3)The actual bar */}
                <div
                    style={{
                        ...borders,
                        width: '100%',
                        height: barHeight,
                        background: 'var(--empty-color)',
                        display: 'flex',
                        alignItems: 'flex-end',
                        boxSizing: 'border-box',
                        overflow: 'hidden',
                        pointerEvents: 'none',
                    }}
                >
                    {val > 0 && (
                        <div
                            style={{
                                width: '100%',
                                height: fillHeight,
                                background: fillColor,
                                borderBottomLeftRadius: BAR_BORDER_RADIUS / 2,
                                borderBottomRightRadius: BAR_BORDER_RADIUS / 2,
                                transition: 'height 0.3s, background 0.3s',
                            }}
                        />
                    )}
                </div>
            </div>
            {hasTitles && (
                <div
                    style={{
                        marginTop: TITLE_MARGIN_TOP,
                        height: TITLE_HEIGHT,
                        fontSize: '12px',
                        fontWeight: isExceeding ? 'extrabold' : 'bold',
                        color: isExceeding ? 'red' : 'var(--dark-color)',
                        textAlign: 'center',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        width: '100%',
                    }}
                    title={title}
                >
                    {title}
                </div>
            )}
        </div>
    )
}
